<template>
	<LayoutList>
		<template slot="header">
            <div style="display: flex; flex-direction: column; ">
                <router-link :to="`/sectors/${id}`" style="margin-bottom: 1rem;">
                    <span>Back</span>
                </router-link>
                <h1>{{ sector.name }} Experts</h1>
            </div>
		</template>
		<input
            slot="search"
            class="form__control"
            type="search"
            placeholder="Search..."
            v-model="filters.query"
        />
		<GridUsers :filters="filters" />
	</LayoutList>
</template>
<script>
	import LayoutList from './../Layout/LayoutList';
	import GridUsers from './../Grid/GridUsers';
	import SvgIcon from '../SvgIcon';
	import { sectorsFlat } from '../../sectors';

	export default {
		name: 'SectorSpecialists',
		components: {
			SvgIcon,
			LayoutList,
			GridUsers,
		},
		props: {
			id: {
				type: Number,
				required: true,
			}
		},
		data() {
			return {
				sector: sectorsFlat.find(sector => sector.id === this.id),
				filters: {
					sectors: [this.id],
					query: '',
				}
			}
		},
	}
</script>
